export const setTvFilmRadioFetchStatusAction = (status) => {
    return { type: 'ALLRESULTS_AUDIOVISUAL_SET_FETCH_STATUS_ACTION', payload: status }
}
export const setTvFilmRadioFetchResultsAction = (results) => {
    return { type: 'ALLRESULTS_AUDIOVISUAL_SET_FETCH_RESULTS_ACTION', payload: results }
}
